import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Loader } from "@itandi/itandi-bb-ui/Loader";
import Link from "next/link";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { ProfileSetting } from "~/components/specifics/vendors/settings/profiles/ProfileSetting";
import { VendorSessionProvider } from "~/context/VendorSession";
import { useSessions } from "~/hooks/vendors/useSessions";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

export function Page() {
	const { data: session, isLoading } = useSessions().index();

	if (isLoading || !session?.vendorUser) {
		return <Loader />;
	}

	return (
		<VendorSessionProvider session={session}>
			<VendorSettingLayout>
				<div className={SettingStyles.SpBreadcrumbsWrapper}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "設定一覧" },
							{ label: "プロフィール詳細" }
						]}
					/>
				</div>
				<ProfileSetting vendorUser={session.vendorUser} />
			</VendorSettingLayout>
		</VendorSessionProvider>
	);
}
